import React from 'react';
import '../App.css';

const Bio = () => {
    return (
        <div id="bio">
            <h2>ARTIST BIO</h2><br />
            <p>A native of Norwich, New York, Tom Pylinski maintains an active
                career as a freelance trombonist and music teacher in Ohio. He is a
                member of the Akron Symphony Orchestra, the Canton Symphony
                Orchestra and the Youngstown Symphony Orchestra. Tom was
                guest principal trombone of the Miami City Ballet during the 2019-
                2020 season. He has performed with the orchestras of Cleveland,
                Columbus, Toledo, Buffalo, Syracuse, South Bend, Wheeling, Erie
                and many others. In addition to his orchestral posts, he is a member
                of the Starkweather Brass Quintet and the brass quintet at the
                Basilica of Saint John the Baptist. He has performed in Canada and
                Europe and given masterclasses at high schools and colleges across
                the United States. He is an Edwards Artist, playing a custom T396-A
                trombone.</p><br /><br />
            <p>Tom has spent summers playing with the Lancaster Festival
                Orchestra, where he has served as principal trombone since 2009. In
                2022 he appeared with the Lake Placid Sinfonietta. He has also
                performed at Tanglewood, the Chautauqua Institution, and in
                Colorado as a fellow of the National Repertory Orchestra. He has
                shared the stage with such notable artists as Kansas, the Beach Boys,
                the O’Jays, the Temptations, Kenny Rogers, Michael Bolton,
                Christopher Cross, Martina McBride, Amy Grant, Todd Rundgren,
                Bela Fleck, Randy Newman, Andrea Bocelli, Idina Menzel, Josh
                Groban and Yo-Yo Ma.</p><br /><br />
            <p>Tom teaches low brass lessons, brass methods and brass chamber
                music at the University of Mount Union and Kent State University
                Stark. He has also taught at the University of Akron, Malone
                University, Ashland University, Old Trail School, the Avon School of
                Music, the Strongsville Academy of Music, the Ohio public school
                system and at the Ohio Music Education Association Convention in
                Columbus. In addition to his performance and teaching posts, Tom
                serves on the literature review staff of the International Trombone
                Association Journal, where he has had published several reviews of
                works for trombone ensemble.</p><br /><br />
            <p>Tom earned a Bachelor of Music degree from the Cleveland Institute
                of Music, where he studied with the late Steve Witser of the
                Cleveland Orchestra. He then earned a Master of Music degree from
                the University of Akron, studying with Ed Zadrozny. Additional
                pedagogues include Rick Stout, Hal Reynolds and John Marcellus.
                Dedicated to representing the interests of professional musicians,
                Tom currently serves as Vice President of Local 24 of the American
                Federation of Musicians. He makes his home in Munroe Falls with
                his wife Janice, who is a music enrichment specialist, and their son
                Matthew.</p><br /><br />
            <p>Click <a href="tom-pylinski-new.pdf" target="_blank">here</a> to view Tom's resume.</p>
        </div>
    )
}

export default Bio;